import React, { useEffect, useState } from 'react';

function Coupons() {
    const [coupons, setCoupons] = useState([]);
    const [poptxt, setPoptxt] = useState('');
    const [poperr, setPoperr] = useState('');
    const [form, setForm] = useState({
        code: '',
        discountType: 'percentage',
        discountValue: '',
        minOrderAmount: '',
        maxUses: '',
        expiresAt: '',
    });

    const fetchCoupons = () => {
        fetch('https://pentadeco.in/api/allcoupons')
            .then(res => res.json())
            .then(data => { if (data.success) setCoupons(data.coupons); })
            .catch(err => console.error('Error fetching coupons:', err));
    };

    useEffect(() => { window.scrollTo(0, 0); fetchCoupons(); }, []);

    const createCoupon = () => {
        if (!form.code || !form.discountValue) {
            setPoperr('Code and discount value are required');
            setTimeout(() => setPoperr(''), 3000);
            return;
        }
        fetch('https://pentadeco.in/api/createcoupon', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({
                code: form.code,
                discountType: form.discountType,
                discountValue: Number(form.discountValue),
                minOrderAmount: Number(form.minOrderAmount) || 0,
                maxUses: form.maxUses ? Number(form.maxUses) : null,
                expiresAt: form.expiresAt || null,
            }),
        })
            .then(res => res.json())
            .then(data => {
                if (data.success) {
                    setPoptxt('Coupon created successfully');
                    setTimeout(() => setPoptxt(''), 3000);
                    setForm({ code: '', discountType: 'percentage', discountValue: '', minOrderAmount: '', maxUses: '', expiresAt: '' });
                    fetchCoupons();
                } else {
                    setPoperr(data.msg);
                    setTimeout(() => setPoperr(''), 3000);
                }
            })
            .catch(err => console.error('Error creating coupon:', err));
    };

    const toggleCoupon = (code) => {
        fetch(`https://pentadeco.in/api/togglecoupon/${code}`)
            .then(res => res.json())
            .then(data => { if (data.success) fetchCoupons(); })
            .catch(err => console.error('Error toggling coupon:', err));
    };

    const deleteCoupon = (code) => {
        if (!window.confirm(`Delete coupon ${code}?`)) return;
        fetch(`https://pentadeco.in/api/deletecoupon/${code}`)
            .then(res => res.json())
            .then(data => { if (data.success) fetchCoupons(); })
            .catch(err => console.error('Error deleting coupon:', err));
    };

    return (
        <div style={{padding: '0 16px 60px'}}>
            <h2 className="body-font-bold fs-4 mt-3 mb-4">Coupon Codes</h2>

            {/* Toasts */}
            {poptxt && <div className="alert alert-success py-2 mb-3 rounded-brand-sm">{poptxt}</div>}
            {poperr && <div className="alert alert-danger py-2 mb-3 rounded-brand-sm">{poperr}</div>}

            {/* ── Create form ── */}
            <div className="bg-white border border-1 rounded-brand p-4 mb-4" style={{boxShadow:'0 2px 10px rgba(0,0,0,0.05)'}}>
                <p className="body-font-bold mb-1" style={{fontSize:'0.95rem'}}>Create New Coupon</p>
                <p className="text-muted mb-3" style={{fontSize:'0.78rem'}}>Fill in the fields below to generate a coupon code</p>

                <div className="row g-2">
                    <div className="col-md-3 col-12">
                        <label className="coupon-label">CODE</label>
                        <input
                            type="text"
                            className="form-control shadow-none rounded-brand-sm"
                            placeholder="e.g. SAVE20"
                            value={form.code}
                            onChange={e => setForm(x => ({ ...x, code: e.target.value.toUpperCase() }))}
                        />
                    </div>
                    <div className="col-md-2 col-6">
                        <label className="coupon-label">TYPE</label>
                        <select
                            className="form-control shadow-none rounded-brand-sm"
                            value={form.discountType}
                            onChange={e => setForm(x => ({ ...x, discountType: e.target.value }))}
                        >
                            <option value="percentage">Percentage (%)</option>
                            <option value="fixed">Fixed (₹)</option>
                        </select>
                    </div>
                    <div className="col-md-2 col-6">
                        <label className="coupon-label">VALUE</label>
                        <input
                            type="number"
                            className="form-control shadow-none rounded-brand-sm"
                            placeholder={form.discountType === 'percentage' ? 'e.g. 20' : 'e.g. 100'}
                            value={form.discountValue}
                            onChange={e => setForm(x => ({ ...x, discountValue: e.target.value }))}
                        />
                    </div>
                    <div className="col-md-2 col-6">
                        <label className="coupon-label">MIN ORDER (₹)</label>
                        <input
                            type="number"
                            className="form-control shadow-none rounded-brand-sm"
                            placeholder="Optional"
                            value={form.minOrderAmount}
                            onChange={e => setForm(x => ({ ...x, minOrderAmount: e.target.value }))}
                        />
                    </div>
                    <div className="col-md-1 col-6">
                        <label className="coupon-label">MAX USES</label>
                        <input
                            type="number"
                            className="form-control shadow-none rounded-brand-sm"
                            placeholder="∞"
                            value={form.maxUses}
                            onChange={e => setForm(x => ({ ...x, maxUses: e.target.value }))}
                        />
                    </div>
                    <div className="col-md-2 col-12">
                        <label className="coupon-label">EXPIRES</label>
                        <input
                            type="date"
                            className="form-control shadow-none rounded-brand-sm"
                            value={form.expiresAt}
                            onChange={e => setForm(x => ({ ...x, expiresAt: e.target.value }))}
                        />
                    </div>
                </div>
                <button
                    className="btn btn-brand-secondary px-4 mt-3 rounded-brand-sm body-font-semibold"
                    onClick={createCoupon}
                >
                    <i className="fas fa-plus me-2"></i>Create Coupon
                </button>
            </div>

            {/* ── Coupon list – desktop table ── */}
            {coupons.length === 0 ? (
                <p className="text-muted text-center py-4">No coupons yet</p>
            ) : (
                <>
                    {/* Desktop */}
                    <div className="d-none d-md-block">
                        <div className="bg-white rounded-brand border overflow-hidden" style={{boxShadow:'0 2px 10px rgba(0,0,0,0.04)'}}>
                            <div className="table-responsive">
                                <table className="table mb-0 align-middle">
                                    <thead style={{background:'#f7f5f2', fontSize:'0.72rem', fontWeight:800, letterSpacing:'0.05em', color:'#888'}}>
                                        <tr>
                                            <th>CODE</th>
                                            <th>TYPE</th>
                                            <th>VALUE</th>
                                            <th>MIN ORDER</th>
                                            <th>USED / MAX</th>
                                            <th>EXPIRES</th>
                                            <th>STATUS</th>
                                            <th>ACTIONS</th>
                                        </tr>
                                    </thead>
                                    <tbody style={{fontSize:'0.82rem'}}>
                                        {coupons.map((c, i) => (
                                            <tr key={i}>
                                                <td className="body-font-bold" style={{letterSpacing:'0.06em'}}>{c.code}</td>
                                                <td className="text-capitalize text-muted">{c.discountType}</td>
                                                <td className="body-font-bold">{c.discountType === 'percentage' ? `${c.discountValue}%` : `₹${c.discountValue}`}</td>
                                                <td className="text-muted">{c.minOrderAmount ? `₹${c.minOrderAmount}` : '—'}</td>
                                                <td className="text-muted">{c.usedCount} / {c.maxUses ?? '∞'}</td>
                                                <td className="text-muted">{c.expiresAt ? new Date(c.expiresAt).toLocaleDateString('en-IN') : '—'}</td>
                                                <td>
                                                    <span className={`badge rounded-pill ${c.isActive ? 'bg-success' : 'bg-secondary'}`} style={{fontSize:'0.72rem'}}>
                                                        {c.isActive ? 'Active' : 'Inactive'}
                                                    </span>
                                                </td>
                                                <td>
                                                    <button
                                                        className={`btn btn-sm rounded-pill me-1 ${c.isActive ? 'btn-outline-secondary' : 'btn-outline-success'}`}
                                                        style={{fontSize:'0.72rem'}}
                                                        onClick={() => toggleCoupon(c.code)}
                                                    >
                                                        {c.isActive ? 'Disable' : 'Enable'}
                                                    </button>
                                                    <button
                                                        className="btn btn-sm btn-outline-danger rounded-pill"
                                                        style={{fontSize:'0.72rem'}}
                                                        onClick={() => deleteCoupon(c.code)}
                                                    >
                                                        Delete
                                                    </button>
                                                </td>
                                            </tr>
                                        ))}
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </div>

                    {/* Mobile cards */}
                    <div className="d-md-none">
                        {coupons.map((c, i) => (
                            <div key={i} className="bg-white border rounded-brand p-3 mb-3" style={{boxShadow:'0 2px 8px rgba(0,0,0,0.04)'}}>
                                <div className="d-flex justify-content-between align-items-start mb-2">
                                    <span className="body-font-bold fs-5" style={{letterSpacing:'0.08em'}}>{c.code}</span>
                                    <span className={`badge rounded-pill ${c.isActive ? 'bg-success' : 'bg-secondary'}`} style={{fontSize:'0.72rem'}}>
                                        {c.isActive ? 'Active' : 'Inactive'}
                                    </span>
                                </div>
                                <div className="d-flex flex-wrap gap-2 mb-3">
                                    <span className="badge bg-warning text-dark rounded-pill" style={{fontSize:'0.72rem'}}>
                                        {c.discountType === 'percentage' ? `${c.discountValue}% OFF` : `₹${c.discountValue} OFF`}
                                    </span>
                                    {c.minOrderAmount > 0 && (
                                        <span className="badge bg-light text-muted border rounded-pill" style={{fontSize:'0.72rem'}}>Min ₹{c.minOrderAmount}</span>
                                    )}
                                    {c.expiresAt && (
                                        <span className="badge bg-light text-muted border rounded-pill" style={{fontSize:'0.72rem'}}>
                                            Expires {new Date(c.expiresAt).toLocaleDateString('en-IN')}
                                        </span>
                                    )}
                                    <span className="badge bg-light text-muted border rounded-pill" style={{fontSize:'0.72rem'}}>
                                        Used {c.usedCount}/{c.maxUses ?? '∞'}
                                    </span>
                                </div>
                                <div className="d-flex gap-2">
                                    <button
                                        className={`btn btn-sm rounded-pill flex-1 ${c.isActive ? 'btn-outline-secondary' : 'btn-outline-success'}`}
                                        style={{fontSize:'0.75rem', flex:1}}
                                        onClick={() => toggleCoupon(c.code)}
                                    >
                                        {c.isActive ? 'Disable' : 'Enable'}
                                    </button>
                                    <button
                                        className="btn btn-sm btn-outline-danger rounded-pill"
                                        style={{fontSize:'0.75rem', flex:1}}
                                        onClick={() => deleteCoupon(c.code)}
                                    >
                                        Delete
                                    </button>
                                </div>
                            </div>
                        ))}
                    </div>
                </>
            )}

            <style>{`
                .coupon-label {
                    display: block;
                    font-size: 0.68rem;
                    font-weight: 800;
                    letter-spacing: 0.06em;
                    color: #999;
                    margin-bottom: 5px;
                }
            `}</style>
        </div>
    );
}

export default Coupons;
